import { RR_LOGO } from "@/lib/constants";

export default function Monogram({ size = "md" }) {
  const dims = { sm: "h-10", md: "h-16", lg: "h-28" }[size];
  return (
    <img
      data-testid="rr-monogram"
      src={RR_LOGO}
      alt="Logo Ritrovo Rinascente"
      className={`${dims} w-auto drop-shadow-[0_4px_12px_rgba(28,27,26,0.18)]`}
    />
  );
}
